import { WalletAddress as WalletAddressView } from '../../wallet-address'

import type { WalletAddress } from '@root/entities/wallet'

type Props = {
  walletAddress: WalletAddress
}

export const WalletAddressCell: React.FC<Props> = ({ walletAddress }) => {
  return <WalletAddressView walletAddress={walletAddress} />
}
